import { render, staticRenderFns } from "./Proj.vue?vue&type=template&id=dfc65d3a&scoped=true&"
import script from "./Proj.vue?vue&type=script&lang=js&"
export * from "./Proj.vue?vue&type=script&lang=js&"
import style0 from "./Proj.vue?vue&type=style&index=0&id=dfc65d3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfc65d3a",
  null
  
)

export default component.exports